import { Link, useLocation, useNavigate } from "react-router-dom";
import css from "./index.module.css";
import useUserData from "@hooks/useUserData";
import { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import usePush from "@hooks/usePush";
import axios from "axios";

export function AdminNavigation() {
  const location = useLocation();
  const { userData } = useUserData();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { subscribe, isSubscribed, isApp, error } = usePush();
  const [unreadChatsCount, setUnreadChatsCount] = useState(0);

  const isActive = (path: string) => {
    const regex = new RegExp(`^${path.replace(/:\w+/g, "\\w+")}$`);
    return regex.test(location.pathname);
  };

  const closeMenu = () => {
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    const loadUnreadChats = () => {
      axios
        .get(`${import.meta.env.VITE_API_ADM_URL}/chats`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        })
        .then((response) => {
          const unreadCount = response.data.filter(
            (user: any) => user.msgStatus === "1"
          ).length;
          setUnreadChatsCount(unreadCount);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    loadUnreadChats();

    const interval = setInterval(() => {
      loadUnreadChats();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <button
        className={css.mobileMenuBtn}
        onClick={() => setIsMobileMenuOpen(true)}
      >
        <i
          style={{ position: "relative", top: 3 }}
          className="fi fi-rr-menu-burger"
        ></i>
      </button>

      {isMobileMenuOpen && (
        <div className={css.mobileMenuOverlay} onClick={closeMenu}></div>
      )}

      <nav
        className={`${css.navbar} ${
          isMobileMenuOpen ? css.mobileMenuOpen : ""
        }`}
        style={{ minWidth: 270 }}
      >
        <div>
          <div className={css.mobileMenuHeader}>
            <h1 style={{ margin: 0 }}>Рыбный мир</h1>
            <button className={css.mobileMenuClose} onClick={closeMenu}>
              <i
                style={{ position: "relative", top: 2, fontSize: 16 }}
                className="fi fi-rr-cross"
              ></i>
            </button>
          </div>
          <div className={css.nv}>
            <Link
              to={"/manage/orders"}
              style={{ marginTop: 5 }}
              className={
                location.pathname === "/manage/orders" ||
                location.pathname === "/manage" ||
                isActive("/manage/order/:id")
                  ? css.active
                  : ""
              }
              onClick={closeMenu}
            >
              Заказы
            </Link>
            <Link
              to={"/manage/chats"}
              className={
                location.pathname === "/manage/chats" ? css.active : ""
              }
              onClick={closeMenu}
            >
              Чат
              {unreadChatsCount > 0 && (
                <span className={css.unreadBadge}>{unreadChatsCount}</span>
              )}
            </Link>
            <Link
              to={"/manage/products"}
              className={
                location.pathname === "/manage/products" ||
                isActive("/manage/product/:id")
                  ? css.active
                  : ""
              }
              onClick={closeMenu}
            >
              Товары
            </Link>
            <Link
              to={"/manage/categories"}
              className={
                location.pathname === "/manage/categories" ||
                isActive("/manage/categories/:id")
                  ? css.active
                  : ""
              }
              onClick={closeMenu}
            >
              Категории
            </Link>
            <Link
              to={"/manage/users"}
              className={
                location.pathname === "/manage/users" ||
                isActive("/manage/user/:id")
                  ? css.active
                  : ""
              }
              onClick={closeMenu}
            >
              Пользователи
            </Link>
            <Link
              to={"/manage/stocks"}
              className={
                location.pathname === "/manage/stocks" ? css.active : ""
              }
              onClick={closeMenu}
            >
              Склады
            </Link>
            {!isSubscribed && !isApp && !isMobile && (
              <Link to={""} onClick={() => subscribe()}>
                <b>Вкл. PUSH-уведомления</b>
              </Link>
            )}
            {isMobile && (
              <Link
                to={"/webapp"}
                className={location.pathname === "/webapp" ? css.active : ""}
                onClick={closeMenu}
              >
                <b>Вернуться в приложение</b>
              </Link>
            )}
            {error && <span>{error}</span>}
          </div>
        </div>

        <Link
          className={`${css.user} ${css.devHidden}`}
          to={`/manage/user/${userData.id}`}
          target="_blank"
        >
          <img
            src="https://amu.edu.kz/upload/default-avatar.jpg"
            alt="avatar"
          />
          <div>
            <b className={css.name}>
              {userData.firstName} {userData.lastName}
            </b>
            <b className={css.access}>
              {userData.access === 1 && "Администратор"}
            </b>
          </div>
        </Link>
      </nav>
    </>
  );
}

export default function Content({ children, isBack = true }: any) {
  const navigate = useNavigate();
  return (
    <div className={css.lexKit}>
      <div className={css.lexKit_body}>
        <AdminNavigation />
        <div className={css.lexKit_content}>
          {isBack && (
            <div className={css.backRow}>
              <button className={css.backBtn} onClick={() => navigate(-1)}>
                <i
                  className="fi fi-rr-arrow-left"
                  style={{ marginRight: 8 }}
                ></i>
                Назад
              </button>
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}
